const BASE_URL = 'https://www.themealdb.com/api/json/v1/1/';

// Get random meals
export async function getRandomMeals(count = 3) {
  try {
    const promises = [];
    for (let i = 0; i < count; i++) {
      promises.push(fetch(`${BASE_URL}random.php`));
    }
    
    const responses = await Promise.all(promises);
    const data = await Promise.all(responses.map(res => res.json()));
    
    return data.map(item => item.meals[0]).filter(Boolean);
  } catch (error) {
    console.error('Error fetching random meals:', error);
    return [];
  }
}

// Search meals by name
export async function searchMeals(query) {
  try {
    if (!query.trim()) return [];
    
    const response = await fetch(`${BASE_URL}search.php?s=${encodeURIComponent(query)}`);
    const data = await response.json();
    
    return data.meals || [];
  } catch (error) {
    console.error('Error searching meals:', error);
    return [];
  }
}

// Get all categories
export async function getCategories() {
  try {
    const response = await fetch(`${BASE_URL}categories.php`);
    const data = await response.json();
    
    return data.categories || [];
  } catch (error) {
    console.error('Error fetching categories:', error);
    return [];
  }
}

// Get meals by category
export async function getMealsByCategory(category) {
  try {
    const response = await fetch(`${BASE_URL}filter.php?c=${encodeURIComponent(category)}`);
    const data = await response.json();
    
    return data.meals || [];
  } catch (error) {
    console.error('Error fetching meals by category:', error);
    return [];
  }
}

// Get meal details by ID
export async function lookupMealById(id) {
  try {
    const response = await fetch(`${BASE_URL}lookup.php?i=${id}`);
    const data = await response.json();
    
    return data.meals ? data.meals[0] : null;
  } catch (error) {
    console.error('Error looking up meal by ID:', error);
    return null;
  }
}